import { JobOptionSvcGroup } from 'domains/jobconfigDomain';
import { useMemo } from 'react';
import { useSvcSubTitle } from './useSvcSubTitle';

interface Iprops {
  svcGroup?: JobOptionSvcGroup;
}

export const useSvcGroupTitle = (props: Iprops) => {
  const { svcGroup } = props;
  const svcSubTitle = useSvcSubTitle();

  const svcName = useMemo(() => {
    return Array.from(
      new Set(
        svcGroup?.svcs.map((svc) => {
          const subTitleObj = svcSubTitle.find(
            (item) =>
              item.revxTypeId === svc.revxTypeId &&
              item.typeName === svc.typeName
          );
          if (subTitleObj) {
            return svc.typeName + subTitleObj.subTitle;
          } else {
            return svc.typeName;
          }
        })
      )
    ).join('/');
  }, [svcGroup?.svcs, svcSubTitle]);

  return svcName;
};
